import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

const pyramidLayers = [
  {
    level: '第三层',
    title: '分档稳定性',
    desc: '',
    detail: '三档诊断比过细排名更加稳妥',
    icon: 'ri-stack-line',
  },
  {
    level: '第二层',
    title: '排序一致性',
    desc: '',
    detail: '内容指数和感染力指数分别捕捉不同信号，融合结果进一步接近综合金标',
    icon: 'ri-sort-asc',
  },
  {
    level: '第一层',
    title: '语义一致性',
    desc: '',
    detail: 'AI要对齐人工，首先要知道人工金标能提供多高的一致性上限',
    icon: 'ri-shield-check-line',
  },
];

export default function P43CredibilityVerify({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.05);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.04);

  return (
    <div className="relative h-screen flex flex-col justify-center overflow-hidden">
      {/* 三层背景光效 */}
      <div ref={orb1Ref} className="absolute top-20 right-24 w-[380px] h-[380px] rounded-full bg-primary-100/14 blur-[130px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-28 left-12 w-[400px] h-[400px] rounded-full bg-accent-100/12 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />
      <div className="absolute top-1/2 left-1/3 w-[300px] h-[300px] rounded-full bg-secondary-200/20 blur-[140px] pointer-events-none animate-orb-float-3" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-10 md:py-14">
        <div ref={titleRef} className="text-center mb-6 md:mb-8">
          <span className="inline-block text-base font-body font-semibold text-accent-600 uppercase tracking-[0.15em] mb-2 transition-all duration-700">验证体系</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 transition-all duration-1000 delay-100">
            可信度验证：<span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">三层体系</span>
          </h2>
          <p className="text-base md:text-lg text-foreground-950 font-body mt-3 max-w-xl mx-auto">把分散证据收成三层体系：金标信度→排序一致性→分档稳定性</p>
        </div>

        {/* 三层金字塔 */}
        <div className="flex flex-col items-center gap-5 md:gap-6 max-w-5xl mx-auto transition-all duration-1000 delay-200">
          {pyramidLayers.map((layer, i) => {
            const widths = ['w-full max-w-xl', 'w-full max-w-2xl', 'w-full max-w-3xl'];
            return (
              <div key={layer.level} className={`${widths[i]} p-5 md:p-6 rounded-xl ${i % 2 === 0 ? 'glass-liquid border-primary-200/30' : 'glass-liquid-gold border-accent-200/30'} transition-all duration-500 hover:scale-[1.01]`} style={{ transitionDelay: `${200 + i * 120}ms` }}>
                <div className="relative z-10">
                  <div className="flex items-center gap-3 mb-2">
                    <div className={`w-11 h-11 rounded-lg flex items-center justify-center ${i % 2 === 0 ? 'glass-blue border-primary-200/40' : 'glass-gold border-accent-200/40'}`}>
                      <i className={`${layer.icon} text-lg ${i % 2 === 0 ? 'text-primary-600' : 'text-accent-600'}`} />
                    </div>
                    <div>
                      <span className="text-sm font-body font-semibold text-foreground-950 leading-none">{layer.level}</span>
                      <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">{layer.title}</h3>
                    </div>
                  </div>
                  {layer.desc && (
                    <p className="text-base text-foreground-950 font-body leading-relaxed">{layer.desc}</p>
                  )}
                  <p className="text-sm text-foreground-950 font-body mt-1 leading-relaxed">{layer.detail}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}